import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OrderStatusStyle, orderStatusStyle } from '../../core/services/order-status.util';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Order status pill — fixed colour + icon per status (same in every restaurant). */
@Component({
  selector: 'app-order-status',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    :host { display: inline-flex; flex-shrink: 0; }
    .os { display: inline-flex; align-items: center; gap: 5px; border-radius: 999px; font-weight: 750; white-space: nowrap; line-height: 1; }
    .sm { font-size: 11.5px; padding: 4px 9px 4px 7px; }
    .md { font-size: 13.5px; padding: 7px 13px 7px 10px; gap: 6px; }
  `],
  template: `<span class="os" [class.sm]="size === 'sm'" [class.md]="size === 'md'" [style.color]="st.color" [style.background]="st.bg">
      <app-icon [name]="st.icon" [size]="size === 'md' ? 16 : 13" [color]="st.color"></app-icon>{{ st.label | t }}
    </span>`,
})
export class OrderStatusComponent {
  st: OrderStatusStyle = orderStatusStyle('');
  private _status = '';
  private _delivery: string | null = null;

  @Input() set status(v: string | null | undefined) { this._status = v || ''; this.refresh(); }
  @Input() set deliveryStatus(v: string | null | undefined) { this._delivery = v ?? null; this.refresh(); }
  @Input() size: 'sm' | 'md' = 'sm';

  private refresh(): void { this.st = orderStatusStyle(this._status, this._delivery); }
}
